import $ from "jquery";
import "./menu-group-colors";
import "./menu-header-colors";
import "./ciq-carousel";
import "./bloc-plan-formation";
import "./page-default-title";
import "./video";

$(document).ready(function () { })